/* eslint-disable react/prop-types */
import React from 'react'

import { IconProps } from '.'

const Save: React.FC<IconProps> = ({ size = 18, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 18 18"
      {...rest}
    >
      <g clipPath="url(#clip0_586_41809)">
        <path
          fill="#2D87F3"
          d="M12.75 2.25h-7.5c-.825 0-1.5.675-1.5 1.5v12L9 13.5l5.25 2.25v-12c0-.825-.675-1.5-1.5-1.5zm0 11.25L9 11.865 5.25 13.5V3.75h7.5v9.75z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_586_41809">
          <path fill="#fff" d="M0 0H18V18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default Save
